var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDefaultGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "#35C0FC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.453 12.7c-.796 0-1.64-.046-2.624-.232-1.921-.371-3.093-1.345-5.436-.881-5.154 1.021-9.606 15.726-3.28 15.911 3.374.093 5.436-3.711 8.013-4.685.703-.278 2.062-.417 3.374-.417s2.671.139 3.374.417c2.577.974 4.639 4.778 8.013 4.685 6.326-.186 1.874-14.891-3.28-15.911-2.343-.464-3.514.557-5.436.881a15.33 15.33 0 0 1-2.718.232zm0-12.2c-2.999 0-5.436 2.412-5.436 5.381s2.437 5.381 5.436 5.381 5.436-2.412 5.436-5.381S17.452.5 14.453.5z",
    fill: "#2B355C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefaultGray);
export default __webpack_public_path__ + "static/media/avatar-default-gray.5ab6b182f7f71d74134de58104505be6a0a89533d53df47dd09eafcd2882b1dc.svg";
export { ForwardRef as ReactComponent };